export enum SkinningFormula {
  Distance = 'distance',
  DistanceChild = 'distance-child',
  DistanceChildTargeting = 'distance-child-targeting',
}
